import { useSelector } from '~/_shared/utils/hooks/useSelector';
import type { AppState } from '~/store/app.store';

const mapSettingsSearchFilterBySelector = (state: AppState) => state.map.mapSettings.data.search.filterBy;
export const useMapSettingsSearchFilterBySelector = () => useSelector(mapSettingsSearchFilterBySelector);

const mapSettingsSearchShouldMatchExactWordsSelector = (state: AppState) => state.map.mapSettings.data.search.shouldMatchExactWords;
export const useMapSettingsSearchShouldMatchExactWordsSelector = () => useSelector(mapSettingsSearchShouldMatchExactWordsSelector);

export const mapSettingsSearchMatchingBehaviorSelector = (state: AppState) => state.map.mapSettings.data.search.selectedMatchingBehaviour;
export const useMapSettingsSearchMatchingBehaviorSelector = () => useSelector(mapSettingsSearchMatchingBehaviorSelector);

export const mapSettingsSearchShouldZoomOnMatchesSelector = (state: AppState) => state.map.mapSettings.data.search.shouldZoomOnMatches;
export const useMapSettingsSearchShouldZoomOnMatchesSelector = () => useSelector(mapSettingsSearchShouldZoomOnMatchesSelector);

export const mapSettingsSearchIsStackingItemsAllowedSelector = (state: AppState) => state.map.mapSettings.data.search.shouldStackItems;
export const useMapSettingsSearchIsStackingItemsAllowedSelector = () => useSelector(mapSettingsSearchIsStackingItemsAllowedSelector);
